<template>
    <DelegateApprovals></DelegateApprovals>
</template>
<script>
    import DelegateApprovals from '@/components/DelegateApprovals.vue'
    export default {
        name: 'funding-management',
        components: {
            DelegateApprovals
        }
    }
</script>